import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Image from '../Image';


const styles = theme =>
  createStyles({
    iconWrap: {
      textAlign: 'center',
      maxWidth: 125,
      justifyContent: 'flex-start',
      margin: '15px 1.8%',
      [theme.breakpoints.up(767)]: {
        margin: '25px 20px 10px 20px'
      },
    },

    iconImageWrap: {
      backgroundColor: theme.palette.grey.main,
      width: 45,
      height: 45,
      margin: '0 auto',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 10,
      [theme.breakpoints.up(450)]: {
        width: 55,
        height: 55,
      },
      [theme.breakpoints.up(767)]: {
        width: 85,
        height: 85,
      },
    },

    iconImage: {
      position: 'relative',
      zIndex: 1,
      width: 25,
      height: 'auto',
      display: 'block',
      [theme.breakpoints.up(450)]: {
        width: 30,
      },
      [theme.breakpoints.up(767)]: {
        width: 45,
      },
    },

    iconDescWrap: {
      textAlign: 'center',
      fontWeight: '400',
      fontSize: 12,
      [theme.breakpoints.up(450)]: {
        fontSize: 14,
      },
      [theme.breakpoints.up(767)]: {
        fontSize: 17,
      },
    }

  });

const SectionIcons = ({
  classes,
  iconImage,
  textAbove,
  textBelow
}) => (

    <div
    className={classes.iconWrap}
    >
    {iconImage && (
        <div className={classes.iconImageWrap}>
            <Image relativePath={iconImage} className={classes.iconImage} />
        </div>
    )}

    <Typography
      variant="body1"
      color="primary"
      className= {classes.iconDescWrap}
      > 
     <strong style={{ fontWeight: '600' }}>{textAbove}</strong> <br/> {textBelow}
    </Typography>

    </div>

  );


export default withStyles(styles, { withTheme: true })(SectionIcons);